import { Box, Button, Typography } from '@mui/material';
import { DNCParamTable } from './DNCParamTable'

const DensityNetworkConfigParams = () => {

    const CreateDNCParamButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"edit-dnc-param"}
        >
            CREATE DNC PARAM
        </Button>
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Density Network Config Params</Typography>
                </Box>
                <Box>
                    <CreateDNCParamButton />
                </Box>
            </Box>
            <DNCParamTable />
        </div>
    )
}

export default DensityNetworkConfigParams;